import {IDataRow, IGroup} from '../model';
import Column from '../model/Column';
import {ERenderMode, ICellRendererFactory, ICellRenderer, IGroupCellRenderer, ISummaryRenderer} from './interfaces';
import {renderMissingDOM} from './missing';
import {noop, noRenderer, setText} from './utils';
import LinkColumn from '../model/LinkColumn';

export default class LinkCellRenderer implements ICellRendererFactory {
  readonly title: string = 'Link';

  canRender(col: Column, mode: ERenderMode): boolean {
    return col instanceof LinkColumn && mode !== ERenderMode.SUMMARY;
  }

  create(col: LinkColumn): ICellRenderer {
    const align = col.alignment || 'left';
    return {
      template: `<a${align !== 'left' ? ` class="lu-${align}"` : ''} target="_blank" href=""></a>`,
      update: (n: HTMLAnchorElement, d: IDataRow) => {
        if (renderMissingDOM(n, col, d)) {
          return;
        }
        const v = col.getLink(d);
        n.href = v ? v.href : '';
        if (col.escape) {
          setText(n, v ? v.alt : '');
        } else {
          n.innerHTML = v ? v.alt : '';
        }
      },
      render: noop
    };
  }

  private static exampleText(col: LinkColumn, rows: IDataRow[]) {
    const numExampleRows = 5;
    const examples = <string[]>[];
    for (const row of rows) {
      if (col.isMissing(row)) {
        continue;
      }
      const v = col.getLink(row);
      examples.push(`<a target="_blank" href="${v ? v.href : ''}">${v ? v.alt : ''}</a>`);
      if (examples.length >= numExampleRows) {
        break;
      }
    }
    return `${examples.join(', ')}${examples.length < rows.length ? ', &hellip;' : ''}`;
  }

  createGroup(col: LinkColumn): IGroupCellRenderer {
    return {
      template: `<div> </div>`,
      update: (n: HTMLDivElement, _group: IGroup, rows: IDataRow[]) => {
        n.innerHTML = LinkCellRenderer.exampleText(col, rows);
      }
    };
  }

  createSummary(): ISummaryRenderer {
    return noRenderer;
  }
}
